import { Metered } from "../types/Metered";
import { EMPTY_LIVENING_ICP_SITES } from "./Sites";

export const EMPTY_METERED: Metered = {
  sites: [EMPTY_LIVENING_ICP_SITES],
};
